// @flow strict
import * as React from 'react'
import { CountrySwitcher } from '@mondough/public-web-components'

import styles from './Footer.module.scss'
import Icons from './Icons'

const countries = [
  {
    key: '🇬🇧 United Kingdom',
    value: '/',
  },
  {
    key: '🇺🇸 United States',
    value: '/usa',
    selected: true,
  },
]

const showCurrentYear = () => new Date().getFullYear()

const USFooter = () => {
  return (
    <footer className={styles.footer}>
      <Icons />
      <div className={styles.container}>
        <div>
          <CountrySwitcher
            label="Switch website"
            countries={countries}
            onChange={(evt: SyntheticInputEvent<HTMLSelectElement>) => {
              if (window) window.location = evt.currentTarget.value
            }}
          />
        </div>
        <ul className={styles.navigation}>
          <li className={styles.item}>
            <a className={styles.link} href="http://monzo.com/careers">
              Join the team
            </a>
          </li>
          <li className={styles.item}>
            <a
              className={styles.link}
              href="mailto:usa-help@monzo.com"
              aria-label="Email us at usa-help@monzo.com"
            >
              usa-help@monzo.com
            </a>
          </li>
          <li className={styles.item}>
            <a
              className={styles.link}
              href="https://webviews.monzo.com/usa/privacy-notice"
              aria-label="Monzo USA Privacy Notice"
            >
              Privacy Notice
            </a>
          </li>
          <li className={styles.item}>
            <a
              className={styles.link}
              href="https://webviews.monzo.com/usa/terms-of-service"
              aria-label="Monzo USA Terms of Service"
            >
              Terms of Service
            </a>
          </li>
        </ul>
        <ul className={styles.navigation}>
          <li className={styles.item}>
            <a
              className={styles.button}
              href="https://twitter.com/monzoUSA"
              aria-label="Follow us on Twitter"
            >
              <svg className={styles.icon}>
                <use
                  xlinkHref="#twitter-bird"
                  href="#twitter-bird"
                  role="presentation"
                />
              </svg>
            </a>
          </li>
          <li className={styles.item}>
            <a
              className={styles.button}
              href="http://facebook.com/monzoUSA"
              aria-label="Follow us on Facebook"
            >
              <svg className={styles.icon}>
                <use
                  xlinkHref="#facebook"
                  href="#facebook"
                  role="presentation"
                />
              </svg>
            </a>
          </li>
        </ul>
        <a href="/" aria-label="Navigate to the Monzo homepage">
          <svg className={styles.logo}>
            <use
              xlinkHref="#monzo-logo"
              href="#monzo-logo"
              role="presentation"
            />
          </svg>
        </a>
      </div>
      <div className={styles.disclaimer}>
        <p>
          This website is operated by Monzo Inc. Monzo reserves the right to
          restrict or revoke any and all offers at any time. The Monzo mobile
          banking app facilitates access to banking services through Sutton
          Bank, Member FDIC. The Monzo Mastercard Debit Card is issued by Sutton
          Bank, pursuant to a license from Mastercard International
          Incorporated. Monzo accounts are FDIC insured up to $250,000.
        </p>
        <p>&copy; {showCurrentYear()} Monzo, Inc. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default USFooter
